// Module
var code = `<div class="deal-ticket">
    {{#if .singleRowText}}
        <div class="js-tercera-label">{{.singleRowText}}</div>
    {{/if}}
    {{#.entries}}
        <div class="js-tercera-label caption">{{.caption}}</div>
        <div class="js-tercera-label value">{{.text}}</div>
    {{/}}
</div>

<div class="js-ticker-screen-footer">
    <reactFormLabel label="{{.text}}">
         <reactCheckbox 
             checked="{{.checked}}" 
             on-onChange="@this.onShowNextTimeChanged(\$1)" />
    </reactFormLabel>
</div>`;
// Exports
export default code;